import { useContext, useState } from "react";
import CreateCourseModal from "../modals/CreateCourseModal";
import { Language } from "../../../App";
import { useCheckSubscriptionPermission } from "../../../hooks/useCheckSubscriptionPermission";
import { MdOutlineSchool, MdArrowForward } from "react-icons/md";

export default function CreateCourseCard() {
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useContext(Language);
  const checkPermission = useCheckSubscriptionPermission("upload_course");

  const toggle = () => {
    if (!checkPermission()) return;
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="cr-create-card">
        <div className="cr-create-top-row">
          <div className="cr-create-circle-icon">
            <MdOutlineSchool size={28} />
          </div>
          <div className="cr-create-text-wrap">
            <h4 className="cr-create-heading">{lang.create_new_course || "Create New Course"}</h4>
            <p className="cr-create-desc">
              {lang.create_course_card_para || "Share your knowledge and connect with doctors worldwide."}
            </p>
          </div>
        </div>

        <button onClick={toggle} className="cr-create-action-btn">
          <span>{lang.create_course || "Create Course"}</span>
          <MdArrowForward size={16} />
        </button>
      </div>

      {isOpen && <CreateCourseModal isOpen={isOpen} toggle={toggle} />}
    </>
  );
}
